export var TaxStatus;
(function (TaxStatus) {
    TaxStatus["EXEMPT"] = "exempt";
    TaxStatus["TAXABLE"] = "taxable";
})(TaxStatus || (TaxStatus = {}));
